import Vue from "vue";
import App from "./App.vue";
import {i18n} from "./i18n";
import router from "./router";
import auth from './auth'
import axios from 'axios'
import store from "./store";
import vuelodash from 'vue-lodash'
import filters from "./filters";
import BootstrapVue from 'bootstrap-vue'
import mixins from './mixins';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

Vue.mixin(mixins);
Vue.use(i18n)
Vue.use(auth)

Vue.use({
    install (Vue) {
    Vue.prototype.$spinnaApi = axios.create({
      baseURL: 'https://api.spinna.wwwworking.de/v1',
      timeout: 4000
    })
  }
})

Vue.use({
    install (Vue) {
    Vue.prototype.$userApi = axios.create({
      baseURL: 'https://spinna.eu.auth0.com/api/v2/',
      timeout: 4000
    })
  }
})

Vue.use(vuelodash)
Vue.use(BootstrapVue);

import moment from 'moment-timezone'
import VueMoment from 'vue-moment'
require('moment/locale/de')

Vue.use(VueMoment, {
    moment
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
